module.exports = __webpack_public_path__ + "img/451575d.jpg";